import { MemberDto, MemberRole, MemberStatus } from './member.dto';

export const MEMBER_ROLE_LABELS: Record<MemberRole, string> = {
  Planner: 'Planista',
  Foreman: 'Brygadzista'
};

export const MEMBER_STATUS_LABELS: Record<MemberStatus, string> = {
  Invited: 'Zaproszony',
  Active: 'Aktywny',
  Deactivated: 'Dezaktywowany'
};

export interface MemberRowVm {
  id: number;
  displayName: string;
  email: string;
  role: MemberRole;
  roleLabel: string;
  isAdmin: boolean;
  status: MemberStatus;
  statusLabel: string;
  /**
   * ISO instant while the sign-in lockout runs, otherwise null — the template formats the hour.
   */
  lockedUntil: string | null;
  lastSignInAt: string | null;
  /**
   * The signed-in administrator's own row: marked (Ty), and never offered Dezaktywuj or Odbierz.
   */
  isYou: boolean;
  /**
   * The only administrator who can sign in: demoting or deactivating them would lock the tenant out.
   */
  isLastActiveAdmin: boolean;
}

export namespace MemberRowVm {
  export function mapModelToViewModel(member: MemberDto, currentEmail: string, activeAdminCount: number): MemberRowVm {
    const activeAdmin = member.isAdmin && member.status === 'Active';

    return {
      id: member.id,
      displayName: member.displayName,
      email: member.email,
      role: member.role,
      roleLabel: MEMBER_ROLE_LABELS[member.role],
      isAdmin: member.isAdmin,
      status: member.status,
      statusLabel: MEMBER_STATUS_LABELS[member.status],
      lockedUntil: member.lockedUntil,
      lastSignInAt: member.lastSignInAt,
      isYou: member.email === currentEmail,
      isLastActiveAdmin: activeAdmin && activeAdminCount === 1
    };
  }

  // Deactivated seats sink to the bottom; within a group the API's order (by name) holds
  export function mapListToViewModels(members: MemberDto[], currentEmail: string): MemberRowVm[] {
    const activeAdminCount = members.filter(x => x.isAdmin && x.status === 'Active').length;

    return members
      .map(member => mapModelToViewModel(member, currentEmail, activeAdminCount))
      .sort((a, b) => Number(a.status === 'Deactivated') - Number(b.status === 'Deactivated'));
  }
}
